import React from "react";

const Audit = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 24 24"
      className="size-6"
    >
      <g>
        <path
          fill="#000000"
          d="M16.25 8V5c0-.689-.561-1.25-1.25-1.25H5c-.689 0-1.25.561-1.25 1.25v14c0 .689.561 1.25 1.25 1.25h10c.689 0 1.25-.561 1.25-1.25v-1a.75.75 0 0 1 1.5 0v1A2.752 2.752 0 0 1 15 21.75H5A2.752 2.752 0 0 1 2.25 19V5A2.752 2.752 0 0 1 5 2.25h10A2.752 2.752 0 0 1 17.75 5v3a.75.75 0 0 1-1.5 0zm-4.5-1a.75.75 0 0 0-.75-.75H6a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 .75-.75zm-3 3A.75.75 0 0 0 8 9.25H6a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 .75-.75zM6 12.25a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5z"
          opacity="1"
          data-original="#112d55"
          class=""
        ></path>
        <path
          fill="#000000"
          d="m21.53 17.47-1.572-1.572c.5-.852.792-1.84.792-2.898 0-3.17-2.58-5.75-5.75-5.75S9.25 9.83 9.25 13s2.58 5.75 5.75 5.75a5.73 5.73 0 0 0 4.032-1.657l1.437 1.437a.748.748 0 0 0 1.06 0 .75.75 0 0 0 0-1.061zM15 17.25c-2.343 0-4.25-1.906-4.25-4.25S12.657 8.75 15 8.75s4.25 1.907 4.25 4.25-1.907 4.25-4.25 4.25zm2.599-5.702a.752.752 0 0 1-.147 1.051l-2.667 2.009a.75.75 0 0 1-.905-.001l-1.333-1.01a.749.749 0 1 1 .905-1.196l.882.667 2.214-1.668a.752.752 0 0 1 1.051.147z"
          opacity="1"
          data-original="#549bff"
          class=""
        ></path>
      </g>
    </svg>
  );
};

export default Audit;
